import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from "lodash";

const Footer = () =>
{
  const { t } = useTranslation();
  const { productUrls, uiTheme } = useSelector((state) => state.activation);
  return (
    <div className="footer" style={{ backgroundColor: uiTheme.bannerColour }}>
        {!isEmpty(productUrls.termsAndConditions) && <a
          href={productUrls.termsAndConditions}
          className="footer-content footer-item has-background"
          style={{ color: uiTheme.bannerColour }}
          target="_blank"
          rel="noreferrer"
        >
          {t('agreementLinks.termsOfUse')}
        </a>}
        {!isEmpty(productUrls.privacyStatement) && <a
          href={productUrls.privacyStatement}
          className="footer-content footer-item has-background"
          style={{ color: uiTheme.bannerColour}}
          target="_blank"
          rel="noreferrer"
        >
          {t('agreementLinks.privacyStatement')}
        </a>}
        {!isEmpty(productUrls.cookieInformation) && <a
          href={productUrls.cookieInformation}
          className="footer-content footer-item has-background"
          style={{ color: uiTheme.bannerColour}}
          target="_blank"
          rel="noreferrer"
        >
          {t('agreementLinks.cookieInformation')}
        </a>}
    </div>
  );
};

export default Footer;
